module.exports = __webpack_public_path__ + "static/media/Dna nucleoide.51d037aa.glb";